const index = "conversation-folder";

const getConversationFolderbyId = (id: string | number) => `${index}/${id}`;

export const conversationFolderEndpoint = Object.freeze({
  conversationFolder: index,
  getConversationFolderbyId,
});
